/**
 * Generate table of contents from markdown/MDX content
 * @param {string} content - Raw markdown content
 * @returns {Array} Array of heading objects
 */
export function extractHeadingsFromDOM(containerSelector = "#article-content") {
  // Wait a bit for content to render
  const container = document.querySelector(containerSelector);
  if (!container) return [];

  const headings = container.querySelectorAll("h1, h2, h3, h4, h5, h6");
  const toc = [];

  headings.forEach((heading) => {
    const level = parseInt(heading.tagName.charAt(1));
    const title = heading.textContent.trim();
    let id = heading.id;

    // Generate ID if it doesn't exist
    if (!id) {
      id = generateHeadingId(title);
      heading.id = id;
    }

    toc.push({
      level,
      title,
      id,
      url: `#${id}`,
    });
  });

  return toc;
}

export function generateHeadingId(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/--+/g, "-")
    .replace(/^-|-$/g, "");
}

export function smoothScrollToElement(elementId, offset = 80) {
  const element = document.getElementById(elementId);
  if (!element) return;

  const yOffset = -offset;
  const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

  window.scrollTo({
    top: y,
    behavior: "smooth",
  });
}
